import * as Yup from "yup";

const passwordField = Yup.string()
  .matches(
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!]).{6,}$/,
    "Password must include uppercase, lowercase, number, and special character"
  )
  .required("Password is required");

export const createFstUserSchema = Yup.object().shape({
  name: Yup.string().trim().required("Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  mobile: Yup.string()
    .matches(/^\d{7,15}$/, "Enter a valid mobile number (7–15 digits)")
    .required("Mobile is required"),
  mobileCountryCode: Yup.string().required("Country is required"),
  mobileCountryCalling: Yup.string().required("Calling code is required"),
  password: passwordField,
  confirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("password")], "Passwords must match"),
});

export const changeFstPasswordSchema = Yup.object().shape({
  password: passwordField,
  confirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("password")], "Passwords must match"),
});
